export default {
    ContentBelongRegularOrInvestment : 'Nội dung thuộc Chi thường xuyên hay Chi đầu tư phát triển',
    ChooseFormula : 'Chọn 1 chỉ tiêu mà bạn muốn thêm công thức vào',
    MessageValidate : 'Vui lòng chọn một chỉ tiêu mà bạn muốn thêm công thức vào.'
};
